/* v94.7 polish round 3 (15 Oct). Loaded sitewide from sections/pw-motto.liquid.
   Faint twinkling stars and an occasional shooting star on the navy hero, the footer motto band and the footer.
   Ported from the v94.3 hero starfield (assets/pw-b.js Sky). One small canvas per host, drawn only while on
   screen and in a visible tab. Reduced motion: the stars are drawn once and stay still, no shooting stars.
   The old footer stars (pw-floof.js) drew nothing under reduced motion and were very sparse on phones, so they are
   switched off (PW_FLOOF_CONFIG.enableStars in pw-motto.liquid) and replaced by this. */
(function () {
  if (window.__pw947r3) return; window.__pw947r3 = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready = function (f) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f); else f(); };

  function Sky(c, o) {
    var x = c.getContext('2d'); if (!x) return;
    var d = Math.min(window.devicePixelRatio || 1, 2), w = 0, h = 0, s = [], sh = [], nx = 1800, last = 0, vis = false, raf = 0;
    function size() {
      var r = c.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (Math.abs(r.width - w) < 2 && Math.abs(r.height - h) < 2) return;
      w = r.width; h = r.height;
      c.width = Math.round(w * d); c.height = Math.round(h * d);
      x.setTransform(d, 0, 0, d, 0, 0);
      var n = Math.min(300, Math.round(w * h / 3600 * o));
      s = [];
      for (var i = 0; i < n; i++) {
        var big = Math.random() < 0.035, q = Math.random();
        s.push({ x: Math.random() * w, y: Math.random() * h, r: big ? 1.2 + Math.random() * 0.9 : 0.3 + Math.random() * 0.85, a: 0.3 + Math.random() * 0.6, sp: 0.4 + Math.random() * 1.8, ph: Math.random() * 6.283, big: big, col: q < 0.22 ? '159,180,255' : q < 0.27 ? '238,196,110' : '255,252,244' });
      }
      draw(performance.now(), 0);
    }
    function spawn() {
      var l = Math.random() < 0.5;
      sh.push({ x: l ? Math.random() * w * 0.6 : w * 0.4 + Math.random() * w * 0.6, y: Math.random() * h * 0.45, dir: l ? 1 : -1, ang: 0.28 + Math.random() * 0.32, v: 0.5 + Math.random() * 0.5, len: 90 + Math.random() * 130, life: 0, max: 900 + Math.random() * 700 });
    }
    function draw(t, dt) {
      if (!w) return;
      x.clearRect(0, 0, w, h);
      var ts = t / 1000;
      for (var i = 0; i < s.length; i++) {
        var p = s[i], tw = RM ? 0.8 : 0.55 + 0.45 * Math.sin(ts * p.sp + p.ph), al = p.a * tw;
        x.fillStyle = 'rgba(' + p.col + ',' + al + ')'; x.beginPath(); x.arc(p.x, p.y, p.r, 0, 6.283); x.fill();
        if (p.big) {
          var g = x.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 6);
          g.addColorStop(0, 'rgba(' + p.col + ',' + al * 0.45 + ')'); g.addColorStop(1, 'rgba(' + p.col + ',0)');
          x.fillStyle = g; x.beginPath(); x.arc(p.x, p.y, p.r * 6, 0, 6.283); x.fill();
        }
      }
      if (RM) return;
      nx -= dt;
      if (nx <= 0) { spawn(); nx = 2600 + Math.random() * 4400; }
      var keep = [];
      for (var j = 0; j < sh.length; j++) {
        var z = sh[j]; z.life += dt; var q = z.life / z.max; if (q >= 1) continue;
        var dd = z.v * z.life, hx = z.x + Math.cos(z.ang) * dd * z.dir, hy = z.y + Math.sin(z.ang) * dd;
        var f = q < 0.15 ? q / 0.15 : q > 0.7 ? (1 - q) / 0.3 : 1, L = z.len * Math.min(1, q * 3);
        var tx = hx - Math.cos(z.ang) * L * z.dir, ty = hy - Math.sin(z.ang) * L;
        var lg = x.createLinearGradient(hx, hy, tx, ty);
        lg.addColorStop(0, 'rgba(255,250,235,' + 0.95 * f + ')'); lg.addColorStop(0.25, 'rgba(200,214,255,' + 0.45 * f + ')'); lg.addColorStop(1, 'rgba(159,180,255,0)');
        x.strokeStyle = lg; x.lineWidth = 1.5; x.lineCap = 'round'; x.beginPath(); x.moveTo(hx, hy); x.lineTo(tx, ty); x.stroke();
        keep.push(z);
      }
      sh = keep;
    }
    function tick(t) {
      raf = 0;
      if (!vis || document.hidden) { last = 0; return; }
      var dt = last ? Math.min(50, t - last) : 16; last = t;
      draw(t, dt);
      raf = requestAnimationFrame(tick);
    }
    function go() { if (!RM && vis && !raf && !document.hidden) raf = requestAnimationFrame(tick); }
    size();
    if ('ResizeObserver' in window) new ResizeObserver(function () { size(); }).observe(c);
    else window.addEventListener('resize', function () { setTimeout(size, 200); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis && !w) size(); go(); }, { rootMargin: '60px' }).observe(c);
    else { vis = true; go(); }
    document.addEventListener('visibilitychange', go);
  }

  function host(el, dens) {
    if (!el || el.__pwsky) return;
    el.__pwsky = 1;
    var c = document.createElement('canvas');
    c.className = 'pw-sky947'; c.setAttribute('aria-hidden', 'true');
    el.classList.add('pw-skyhost');
    el.insertBefore(c, el.firstChild);
    Sky(c, dens);
  }

  function boot() {
    var hero = document.querySelector('.ns-hero');
    if (hero && !hero.querySelector('canvas.pwb-sky')) host(hero, 1.05);
    host(document.querySelector('.pw-motto'), 1.1);
    var ft = document.querySelector('footer.footer') || document.querySelector('.footer');
    if (ft) {
      [].forEach.call(ft.querySelectorAll('canvas[data-pw-stars]'), function (e) { e.remove(); });
      host(ft, 1);
    }
  }
  ready(boot);
  document.addEventListener('shopify:section:load', boot);
})();
